import { render, staticRenderFns } from "./ContactRelationsList.vue?vue&type=template&id=5563ece0&scoped=true"
import script from "./ContactRelationsList.vue?vue&type=script&lang=js"
export * from "./ContactRelationsList.vue?vue&type=script&lang=js"
import style0 from "./ContactRelationsList.vue?vue&type=style&index=0&id=5563ece0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563ece0",
  null
  
)

export default component.exports